{
  "0xc56873ba": "OrderExpired",
  "0xa4f62a96": "BitInvalidatedOrder",
  "0x0977240b": "SwapError",
  "0x1c27d2c0": "SwapError"
}
